module.exports = __webpack_public_path__ + "img/tips6@x2.880fbfd3.png";